export default __webpack_public_path__ + "static/media/thumbs-up.6a7b3c0a.png";